export function EmptyToolPage({ title }) {
  return (
    <main className="civita-page">
      <header className="civita-page-heading">
        <span>Civita</span>
        <h1>{title}</h1>
      </header>
    </main>
  );
}
